import React, { useState } from "react";
import { Container, } from "semantic-ui-react";
import StepOne from "../StepOne/StepOne"
import StepTwo from '../StepTwo/StepTwo';
import StepThree from '../StepThree/StepThree';
import Spinner from '../../Shared/Spinner/Spinner';

import "./Steps.scss";

export function Steps() {

  const [step, setStep] = useState(1);
  const [selectedDebt, setSelectedDebt] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    documentType: '',
    documentNumber: '',
    birthYear: '',
    termsAccepted: false,
  });

  const nextStep = (data) => {
    setStep(step + 1);
    if (step === 1) {
      setFormData({ ...formData, ...data });
    } else if (step === 2) {
      setSelectedDebt(data);
    }
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  return (
    <>
    {loading && <Spinner text="Consultando información." />}

    <Container className="step-container" style={{ display: loading ? 'none' : 'block' }}>
      <div className="step-icons">
        <div className={`step-icon ${step >= 1 ? "active" : ""}`}>
        </div>
        <div className={`step-icon ${step >= 2 ? "active" : ""}`}>
        </div>
        <div className={`step-icon ${step >= 3 ? "active" : ""}`}>
        </div>
        <div className={`step-icon ${step >= 4 ? "active" : ""}`}>
        </div>
      </div>

      {step === 1 && <StepOne nextStep={nextStep} formData={formData} setLoading={setLoading}/>}
      {step === 2 && <StepTwo formData={formData} nextStep={nextStep} prevStep={prevStep} setSelectedDebt={setSelectedDebt}/>}
      {step === 3 && <StepThree prevStep={prevStep} selectedDebt={selectedDebt} setLoading={setLoading}/>}

    </Container>
    </>
  );
}

export default Steps;